import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import Typography from '../Typography/Typography';
import Tooltip from '../Tooltip';
import { Button } from '../Button/Button';
import { sideNavBarCSS } from './sideNavBarColors';

export interface SideNavBarMenuItem {
  label: string;
  icon?: JSX.Element;
  id: string;
  onClick?: () => void;
  selected: boolean;
}

export const SideNavBarItem: FC<React.PropsWithChildren<SideNavBarMenuItem>> = ({
  label,
  icon,
  id,
  onClick,
  selected
}) => (
  <StyledButton
    className="nav-bar-list-item"
    active={selected}
    id={id}
    key={id}
    fullWidth
    onClick={onClick}
    dataTest={`${id}-expanded-link`}
  >
    {icon && <Tooltip title={label}>{icon}</Tooltip>}
    <StyledLabel className="nav-bar-label" variant="label1" dataTest="nav-bar-label">
      {label}
    </StyledLabel>
  </StyledButton>
);
export const SideNavBarItemCss = css`
  &.MuiButtonBase-root {
    height: 40px;
    min-width: 42px;
    border-radius: ${sideNavBarCSS.menuItem.borderRadius};
    .MuiButton-label {
      transition-property: padding, gap;
      transition-duration: 0.2s;
      transition-timing-function: ease-out;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      // justify icon in the tooltip
      > span {
        display: flex;
        width: 24px;
        height: 24px;
      }
    }

    &:hover {
      border-radius: ${sideNavBarCSS.menuItem.borderRadius};
      &[data-test-active='true']:after {
        background-color: ${({ theme }) => theme.colorSecondaryContainer};
        color: ${({ theme }) => theme.colorOnSecondaryContainer};
        border-radius: ${sideNavBarCSS.menuItem.borderRadius};
      }
    }
    &[data-test-active='true']:after {
      background-color: ${({ theme }) => theme.colorSecondaryContainer};
      color: ${({ theme }) => theme.colorOnSecondaryContainer};
      border-radius: ${sideNavBarCSS.menuItem.borderRadius};
    }
  }
`;
const StyledButton = styled(Button)`
  ${SideNavBarItemCss}
`;

const StyledLabel = styled(Typography)`
  color: ${sideNavBarCSS.label};
  text-align: left;
`;
